import {
  FaFacebookF,
  FaInstagram,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";
import { AiFillTikTok } from "react-icons/ai";

const ShareFollow = () => {
  return (
    <div className="rounded-2xl bg-white p-4 shadow-sm ring-1 ring-slate-100">
      <h3 className="text-lg font-extrabold text-slate-900">Share & Follow</h3>
      <p className="mt-2 text-sm text-slate-600">
        Follow our social channels for offers and new arrivals.
      </p>
      <div className="mt-3 flex items-center gap-2">
        <a
          href="https://www.facebook.com/share/1AoiGtts1W/"
          target="_blank"
          rel="noreferrer"
          className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-700 transition hover:bg-slate-200"
        >
          <FaFacebookF />
        </a>
        <a
          href="instagram.com"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-700 transition hover:bg-slate-200"
        >
          <FaInstagram />
        </a>
        <a
          href="https://tiktok.com"
          target="_blank"
          rel="noreferrer"
          className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-700 transition hover:bg-slate-200"
        >
          <AiFillTikTok />
        </a>
        <a
          href={`https://wa.me/8801971787661`}
          target="_blank"
          rel="noreferrer"
          className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-700 transition hover:bg-slate-200"
        >
          <FaWhatsapp />
        </a>
        <a
          href="youtube.com"
          target="_blank"
          rel="noreferrer"
          className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-700 transition hover:bg-slate-200"
        >
          <FaYoutube />
        </a>
      </div>
    </div>
  );
};

export default ShareFollow;
